
<template>
  <div class="workspace">
    <TopHeader />
    <Navi />
    <fluidBend />

    <div class="profile_wrapper">
      <div class="container">
        <b-row class="buttonbox">
          <b-col sm="12" lg="12">
            <b-input
              type="password"
              placeholder="신규비밀번호"
              v-model="newpassword"
            ></b-input>
          </b-col>
        </b-row>

        <b-row class="buttonbox">
          <b-col sm="12" lg="12">
            <b-button variant="primary" size="sm" @click="update"
              >수정</b-button
            >
          </b-col>
        </b-row>
        <hr />

        <b-row class="buttonbox">
          <b-col sm="3" lg="3" class="headtitle"> 생성한 문항수: </b-col>
        </b-row>
        <b-row class="buttonbox">
          <b-col class="bodytitle"> {{ qcount }} </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Navi from "@/components/Navi";
import TopHeader from "@/components/Header";
import FluidBend from "@/components/FluidBend";

import axios from "axios";
const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;

export default {
  components: { Navi, TopHeader, FluidBend },
  mounted() {
    let userid = this.$cookies.get("user_id");
    this.$store.dispatch("updateTotalQCountByID", userid);
  },
  data() {
    return {
      newpassword: null,
    };
  },
  computed: {
    qcount() {
      return this.$store.state.totalQcountByID;
    },
  },

  methods: {
    async update() {
      let user_id = this.$cookies.get("user_id");
      let url = `${SERVER_URL}/changepw/${user_id}`;
      try {
        let resp = await axios.put(url, {
          newpassword: this.newpassword,
        });
        alert("비밀번호가 변경되었습니다");
      } catch (err) {
        alert(err.response.data.msg);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.profile_wrapper {
  margin-top: 25px;
}
.buttonbox {
  margin-top: 10px;
  text-align: center;
}
.headtitle {
  font-size: 1.1em;
  color: $color1;
}
.bodytitle {
  font-size: 7em;
  color: $color1;
  font-weight: 700;
}
</style>